import { styled } from "@mui/material/styles";
import { ToggleButton } from "@mui/material";

const ToggleButtonStyled = styled(ToggleButton)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'inherit',
  '&.Mui-disabled' : {
    color: '#7bb1e3'
  }
}));

export default ToggleButtonStyled;